import { render, staticRenderFns } from "./goBack.vue?vue&type=template&id=a9d53a12&scoped=true&"
import script from "./goBack.vue?vue&type=script&lang=js&"
export * from "./goBack.vue?vue&type=script&lang=js&"
import style0 from "./goBack.vue?vue&type=style&index=0&id=a9d53a12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9d53a12",
  null
  
)

export default component.exports